module.exports = __webpack_public_path__ + "img/buzzlogo@2x.c1287551.png";